<template>
  <div class="maintenancePlan mainPageBg">
    <Mybreadcrumb v-model="innerPath"
      :label-args="{ title2: active.title2, title3: active.title3 }"
      :showInRoot="showInRoot"
      :path="{
        label:title,
        key: '1',
        children: [
          {
            label: title1,
            key: '2',
            children: [
              {
                label: title2,
                key: '3',
              },
            ],
          },
        ],
      }"></Mybreadcrumb>
    <div style="height: calc(100% - 45px)">
      <PlanMainPage v-if="innerPath == 1"
        @sentIndexFn="sentIndexFn"
        style="height: 100%"></PlanMainPage>
      <PlanDetails v-else-if="innerPath == 2"
        @sentPoints="sentPoints"
        :detailData="detailData"
        style="height: 100%"></PlanDetails>
      <PointsDetails v-else-if="innerPath == 3"
        :detailData="pointsData"
        style="height: 100%" />
    </div>
  </div>
</template>

<script>
import Mybreadcrumb from "@/components/houqinguanli/xunjianguanli/Mybreadcrumb.vue";
import PlanMainPage from "@/components/houqinguanli/planCom/PlanMainPage.vue";
import PlanDetails from "@/components/houqinguanli/planCom/mainPage/PlanDetails.vue";
import PointsDetails from "@/components/houqinguanli/planCom/mainPage/PointsDetails.vue";
export default {
  components: {
    Mybreadcrumb,
    PlanMainPage,
    PlanDetails,
    PointsDetails,
  },
  data() {
    return {
      // 层级设置
      showInRoot: true, //是否显示第一个标题，是根节点
      innerPath: 1,
      active: { title2: "", title3: "" }, //这是动态标题，值可以在某件事件触发时，赋值
      detailData: {},
      pointsData: {},
      title: "",
      title1: "",
      title2: "",
    };
  },
  methods: {
    sentIndexFn(data) {
      // console.log(data);
      this.innerPath = data.index;
      this.detailData = data.row;
    },
    sentPoints(data) {
      this.innerPath = data.index;
      this.pointsData = data.row;
    },
  },
  created() {
    if (this.$route.path == "/maintainPlan") {
      this.title = "保养计划";
      this.title1 = "保养计划详情";
      this.title2 = "设备保养详情";
    } else if (this.$route.path == "/patrolPlan") {
      this.title = "巡检计划";
      this.title1 = "巡检计划详情";
      this.title2 = "巡检点详情";
    }
  },
};
</script>

<style lang="scss" scoped>
</style>